import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Link } from "react-router-dom";
import "./style.css";

const Footer = () => {
  const quickLink = [
    {
      text: "Home",
      link: "/",
    },
    {
      text: "About Us",
      link: "/about-us",
    },
    {
      text: "FAQs",
      link: "/faqs",
    },
    {
      text: "Contact Us",
      link: "/contact-us",
    },
    {
      text: "Terms & Conditions",
      link: "/terms-and-conditions",
    },
  ];

  const customerServices = [
    {
      text: "Help Center",
      link: "/contact-us",
    },
    {
      text: "Privacy Policy",
      link: "/privay-policy",
    },
  ];

  return (
    <footer id="footer" className="overflow-hidden bg-light py-4">
      <Container>
        <Row className="footer-top-area d-flex flex-wrap justify-content-between">
          {/* Left Side: Logo & Description */}
          <Col lg={3} sm={6} className="pb-3">
            <div className="footer-menu">
              <LinkContainer
                to="/"
                style={{
                  cursor: "pointer",
                  color: "#0d6efd",
                  fontWeight: "700",
                }}
              >
                <img
                  src="/images/datacom_newlogo.png"
                  alt="logo"
                  className="mb-2"
                  // width="230"
                  height="70px"
                />
                {/* <h2
                  style={{
                    fontSize: "30px",
                  }}
                >
                  DATACOM
                </h2> */}
              </LinkContainer>
              <p
                style={{
                  marginTop: "15px",
                }}
              >
                Your Trusted Destination for Premium Mobile Phones – Offering
                the Latest Technology, Best Deals, and Exceptional Service.
              </p>
              {/* <div className="social-links">
                <ul className="d-flex list-unstyled gap-3">
                  <i className="bi bi-facebook"></i>
                  <i className="bi bi-instagram"></i>
                  <i className="bi bi-twitter-x"></i>
                  <i className="bi bi-linkedin"></i>
                  <i className="bi bi-youtube"></i>
                </ul>
              </div> */}
            </div>
          </Col>

          {/* Quick Links */}
          <Col lg={2} sm={6} className="pb-3">
            <div className="footer-menu text-uppercase">
              <h5 className="widget-title pb-2">Quick Links</h5>
              <ul className="menu-list list-unstyled text-uppercase">
                {quickLink.map((item, index) => (
                  <li className="menu-item pb-2" key={index}>
                    <Link to={item.link}>{item.text}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </Col>

          {/* Help & Info */}
          <Col lg={3} sm={6} className="pb-3">
            <div className="footer-menu text-uppercase">
              <h5 className="widget-title pb-2">Customer Service</h5>
              <ul className="menu-list list-unstyled">
                {customerServices.map((item, index) => (
                  <li className="menu-item pb-2" key={index}>
                    <Link to={item.link}>{item.text}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </Col>

          {/* Contact Info */}
          <Col lg={3} sm={6} className="pb-3">
            <div className="footer-menu contact-item">
              <h5 className="widget-title text-uppercase pb-2">Contact Us</h5>
              <p>
                Do you have any queries or suggestions?{" "}
                <a
                  href="mailto:support@datacomco.com"
                  style={{ fontWeight: 600 }}
                >
                  support@datacomco.com
                </a>
              </p>
              <p>
                If you need a support? Just give us a call.
                <br />
                <a href="tel:+1 929-346-1108" style={{ fontWeight: 600 }}>
                  (929) 346-1108
                </a>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
      <hr />
    </footer>
  );
};

export default Footer;
